export const SELECTION_KEY = 'mcp-entitlements';

export const SECTION_NAME = 'MCP Entitlements';

export const NO_ASSIGNED_ENTITLEMENT_TITLE =
    'There are currently no MCP resources assigned to this account. ' +
    'Please use the "Assign Resource(s)" button to assign access to a new MCP resource.';

export const NO_ASSIGNED_ENTITLEMENT_DESCRIPTION =
    'If you do not have access to the "Assign Resource(s)" button on this page, ' +
    'please reach out to the PB Admin team to request an entitlement update.';
